import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';

export interface DeactivationGuarded {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ConfirmDeactivateGuard implements CanDeactivate<any>  {

  constructor(
  ) {
  }

  canDeactivate(target: DeactivationGuarded) {
    return target.canDeactivate ? target.canDeactivate() : true;
  }
}
